export const EMAIL_VALIDATION_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailAddress(email) {
  return EMAIL_VALIDATION_REGEX.test(email);
}
